import { render, staticRenderFns } from "./DocumentManagementPane.vue?vue&type=template&id=87352e44&scoped=true"
import script from "./DocumentManagementPane.vue?vue&type=script&lang=js"
export * from "./DocumentManagementPane.vue?vue&type=script&lang=js"
import style0 from "./DocumentManagementPane.vue?vue&type=style&index=0&id=87352e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87352e44",
  null
  
)

export default component.exports